export default class CustomSearch {
  
  constructor() {
    console.log("test 122");
    const form = document.getElementById('searchForm'),
    self = this,
    searchInputHero = document.getElementById("homeTxtSearchTerm"),
    searchTopInputHero = document.getElementById("topTxtSearchTerm");
    
    // Function to add event listeners to search input
    function addSearchListeners(inputElement, buttonSelector) {
      if (inputElement) {
        // Store on input change
        inputElement.addEventListener('input', function() {
          sessionStorage.setItem('lastSearch', this.value);
        });
        
        // Store on Enter key
        inputElement.addEventListener('keyup', function(e) {
          if (e.key === 'Enter') {
            sessionStorage.setItem('lastSearch', this.value);
          }
        });
        
        // Store on button click
        const searchButton = document.querySelector(buttonSelector);
        if (searchButton) {
          searchButton.addEventListener('click', function() {
            sessionStorage.setItem('lastSearch', inputElement.value);
          });
        }
      }
    }
    
    // Add listeners to both search inputs
    addSearchListeners(searchInputHero, '#homeSearch button');
    addSearchListeners(searchTopInputHero, '#topSearch button');
    
    if (form) {
      this.form = form;
      this.showResults();
    }
    
    $(function() {
      $('#btnSearch').show().click(function() { 
        self.Search($("#txtSearchTerm").val(), 0);
      });
      
      $('#lnkPrev').click(function() { 
        self.Search($("#txtSearchTerm").val(), -1);
      });
      
      $('#lnkNext').click(function() { 
        self.Search($("#txtSearchTerm").val(), 1);
      });
    });
  }
  SearchCompleted(response)
  {
    var _prevIndex = 0;
    var _nextIndex = 0;
    var _resultsPerPage = 10;
    var _pageNumber = 1;
    var html = "";
    
    $("#searchResult").html("");
    
    // if (response.items == null)
    //   {
    //   $("#searchResult").html("No matching pages found");
    //   return;
    // }
    
    // if (response.items.length === 0)
    //   {
    //   $("#searchResult").html("No matching pages found");
    //   return;
    // }
    
    // console.log(response.queries.request[0]);
    // $("#searchResult").html(response.queries.request[0].totalResults + " pages found for <b>" +response.queries.request[0].searchTerms+ "</b>");
    
    if (response.queries.nextPage != null)
      {
      _nextIndex = response.queries.nextPage[0].startIndex;
      $("#lnkNext").show();
    }
    else
    {
      $("#lnkNext").hide();
    }
    
    if (response.queries.previousPage != null)
      {
      _prevIndex = response.queries.previousPage[0].startIndex;
      $("#lnkPrev").show();
    }
    else
    {
      $("#lnkPrev").hide();
    }
    
    if (response.queries.request[0].totalResults > _resultsPerPage){
      $("#lblPageNumber").show().html(_pageNumber);
    }
    else{
      $("#lblPageNumber").hide();
    }
    
    for (var i = 0; i < response.items.length; i++){
      
      var item = response.items[i];
      var title = item.htmlTitle;
      
      html += "<div class='search-result-item margin-top-m'><h3><a class='searchLink' href='" + item.link + "'> " + title + "</a></h3>";
      html += "<div class='result-link-text'><cite>" + item.link + "</cite> - <a class='result-link-cache' href='http://www.google.com/search?q=cache:"+item.cacheId+":"+item.displayLink+"'><small>Cached</small></a></div>";
      html += "<div>" + item.snippet + "</div></div>"; 
      
    }
    $("#output").html(html);
  }
  Search(term, direction)
  {
    var _prevIndex = 0;
    var _nextIndex = 0;
    var _pageNumber = 1;
    var startIndex = 1;
    
    if (direction === -1)
      {
      startIndex = _prevIndex; 
      _pageNumber--;
    }
    if (direction === 1)
      {
      startIndex = _nextIndex; 
      _pageNumber++;
    }
    if (direction === 0)
      {
      startIndex = 1; 
      _pageNumber = 1;
    }
    
    var url = "https://www.googleapis.com/customsearch/v1?key="
    + mGoogleApiKey + "&num=10&cx=" + mGoogleCustomSearchKey + "&start=" + startIndex + "&q=" + escape(term) + "&excludeTerms=.aspx .pdf .html&callback=?";
    
    $.getJSON(url, '', this.SearchCompleted.bind(this));
  }
  showResults() {
    let searchForm = document.getElementById("searchForm"),
    searchInput = document.getElementById("txtSearchTerm");
    
    const self = this;
    
    if (!searchForm || !searchInput) return;
    
    let searchTermFormSession = sessionStorage.getItem("lastSearch");
    let searchTerm = searchInput.value;
    
    console.log({searchTermFormSession});
    console.log({searchTerm});
    
    window.onload = function(event) {
      // Only process if we have a stored search AND we're not coming from a form submission
      const isFromSubmit = sessionStorage.getItem("search_q") === searchTerm;
      
      if (searchTermFormSession && !isFromSubmit) {
        searchInput.value = searchTermFormSession;
        self.Search(searchTermFormSession, 0);
        
        if (searchTermFormSession !== searchTerm) {
          event.preventDefault();
          setTimeout(() => {
            searchForm.dispatchEvent(new Event("submit", { 
              bubbles: true, 
              cancelable: true 
            }));
          }, 100);
        }
        sessionStorage.removeItem("lastSearch");
      }
    };
    
    document.addEventListener("keyup", function (event) {
      var key = event.key || event.keyCode;
      if (key === 13 || key === 'Enter') {
        event.preventDefault();
        searchForm.dispatchEvent(new Event("submit"));
      }
    });
    
    searchForm.addEventListener("submit", function (event) {
      event.preventDefault();
      sessionStorage.setItem("search_q", searchInput.value);
      let hash = `#stq=${searchInput.value}`;
      let actionWithHash = searchForm.action + hash;
      searchForm.method = "POST";
      searchForm.action = actionWithHash;
      searchForm.submit();
    });
  }
}